export enum SeatType {
  ContractRoom = 'contractroom',
  DealRoom = 'dealroom',
  Suite = 'suite',
}
